import { get } from 'lodash';
import { isEmptyString } from '@vy/utils';
import { Controller, useFormContext } from 'react-hook-form';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { VyTextField } from '@vy/ui-design-system';

type SeatsInputProps = {
  productIndex: number;
};

export const SeatsInput: React.FC<SeatsInputProps> = ({ productIndex }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<PlanInputForm>();

  const seatsFieldName = `fixedProducts.${productIndex}.variants.0.pricing.priceConfiguration.seats` as const;
  const message = get(errors, seatsFieldName)?.message as string | undefined;

  return (
    <Controller
      control={control}
      name={seatsFieldName}
      render={({ field }) => (
        <VyTextField
          label="Seats"
          placeholder="# of seats"
          helperText={message ?? 'Adjust the number of seats per subscription'}
          type="number"
          fullWidth
          value={field.value ?? ''}
          onChange={(event) => {
            if (isEmptyString(event.target.value)) {
              field.onChange(undefined);
              return;
            }
            const parsed = Number(event.target.value);
            field.onChange(Number.isNaN(parsed) ? undefined : Math.max(0, parsed));
          }}
          onBlur={field.onBlur}
          inputRef={field.ref}
          error={Boolean(message)}
          slotProps={{ htmlInput: { min: 0, step: 1 } }}
          data-vy="plan-charge-drawer-seats-input"
        />
      )}
    />
  );
};
